"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// consists of BE status and custom status
exports.default = {
    COMPLETED_WITH_FAILURE: 'COMPLETED_WITH_FAILURE',
    COMPLETE: 'COMPLETE',
    POLL_TIMEOUT: 'POLL_TIMEOUT',
};
